import { Button, Input, Select, Space } from 'antd'
import React, { memo, useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { ConfigItem, SelectInputSetting } from '../..'
import { SearchOutlined } from '@ant-design/icons'

export interface ChangeParamsType {
    key?: string
    value?: string
}
interface IProps {
    schemas: ConfigItem[]
    onChange?: (e: ChangeParamsType) => void
    selectInputSetting: SelectInputSetting
    onSearch: (e: ChangeParamsType) => void
}

const Index = ({ schemas, onChange, selectInputSetting, onSearch }: IProps) => {
    const [input, setInput] = useState("");
    const [options, setOptions] = useState([]);
    const [setSelectValue, setSetselectValue] = useState("");
    const changeDataRef = useRef<ChangeParamsType>({})
    // console.log("schemas", schemas)
    // console.log("options", options)

    const triggerChange = v => {
        onChange?.(v)
    }
    const handleInputValueChange = e => {
        // triggerChange(e.target.value)
        setInput(e.target.value)
        changeDataRef.current.value = e.target.value
        onChange?.(changeDataRef.current)
    }
    const onSelectChange = (e: any, optionData: any) => {
        setInput("")
        setSetselectValue(e)
        changeDataRef.current.value = ""
        changeDataRef.current.key = optionData.value
        onChange?.(changeDataRef.current)
    }
    const handleSearch = () => {
        onSearch(changeDataRef.current)
    }

    useEffect(() => {
        const res = schemas.map(i => ({
            label: i.label,
            value: i.name
        }))
        setOptions(res)
        if (res.length) {
            setSetselectValue(res[0].value)
            changeDataRef.current.key = res[0].value
        }
    }, [schemas])

    return (<div style={{ width: `${selectInputSetting?.width || 290}px` }}> <Space.Compact block>
        {/* <div className={styles.addon}>{label}</div> */}
        <Select value={setSelectValue}
            // allowClear
            style={{ width: selectInputSetting?.selectWidth || 150 }}
            options={options}
            onChange={onSelectChange} />
        <Input
            value={input}
            onChange={handleInputValueChange}
            // addonAfter={<div onClick={handleBtnClick} > 搜索</div>}
            width={selectInputSetting?.inputWidth || 80}
            placeholder="请输入"
            onPressEnter={handleSearch}
            allowClear
        />
        <Button onClick={handleSearch}>搜索</Button>
    </Space.Compact></div>)
}

export default Index